module.exports = __webpack_public_path__ + "static/media/openFromHomeScreen.34e43282.jpg";